class FICColors {
}

FICColors.white = '#FFFFFF'
FICColors.blue = '#0D97D5'
FICColors.lightBlue = '#E0EAF9'
FICColors.deepBlue = '#007CE4'
FICColors.green = '#13CE64'
FICColors.darkGreen = '#00875A'
FICColors.black = '#333333'
FICColors.gray = '#EBEDEE'
FICColors.darkGray = '#7B8B93'
FICColors.borderColor = '#AAB4B9'
FICColors.inputDisabled = '#EBEDEE'
FICColors.inputDisabledText = '#BDC5C8'
FICColors.placeholder = '#94A1A7'
FICColors.boxBackgroundColor = '#F8F9F9'

// black
FICColors.black100 = '#333333'

// blue
FICColors.blue50 = '#E4F3FA'
FICColors.blue100 = '#C6E7F5'
FICColors.blue200 = '#A4D8EF'
FICColors.blue300 = '#7DC8E8'
FICColors.blue400 = '#4DB4E0'
FICColors.blue500 = '#0D97D5'
FICColors.blue600 = '#0B8AC0'
FICColors.blue700 = '#0A79A8'
FICColors.blue800 = '#08648B'
FICColors.blue900 = '#064763'

// grey
FICColors.grey50 = '#FAFAFA'
FICColors.grey100 = '#EBEDEE'
FICColors.grey300 = '#A8B3B8'
FICColors.grey500 = '#6F7E86'
FICColors.grey600 = '#65747B'
FICColors.grey700 = '#5A676D'
FICColors.grey900 = '#22282B'

// red
FICColors.red = '#FF4949'
FICColors.red500 = '#DE350B'
FICColors.red600 = '#DA300A'

// yellow / orange
FICColors.yellow300 = '#FFB862'

FICColors.form = {
  field: {
    label: FICColors.black,
    validationMessage: FICColors.red,
    description: FICColors.darkGray
  }
}

FICColors.button = {
  primary: {
    blue: {
      normal: FICColors.blue,
      hover: '#0B8AC0',
      active: '#08648b',
      disabled: '#C6E7F5',
      text: FICColors.white,
      textHover: FICColors.white
    },
    red: {
      normal: FICColors.red,
      hover: '#ca3839',
      active: '#a72f2f',
      disabled: '#FFD8D8',
      text: FICColors.white,
      textHover: FICColors.white
    },
    green: {
      normal: FICColors.green,
      hover: '#0fa34e',
      active: '#0c8742',
      disabled: '#C7F3DA',
      text: FICColors.white,
      textHover: FICColors.white
    },
    white: {
      normal: FICColors.white,
      hover: FICColors.grey100,
      active: '#ebedee',
      disabled: '#F8F9F9',
      text: FICColors.black,
      textHover: FICColors.black
    },
    whiteBlue: {
      normal: FICColors.white,
      hover: FICColors.grey100,
      active: '#ebedee',
      disabled: '#F8F9F9',
      text: FICColors.blue,
      textHover: FICColors.black
    }
  },
  secondary: {
    blue: {
      normal: FICColors.lightBlue,
      hover: '#B3CBF0',
      active: '#80A9E6',
      disabled: FICColors.boxBackgroundColor,
      text: '#0052CC',
      textHover: '#0052CC'
    },
    red: {
      normal: '#ffecec',
      hover: '#ffd8d8',
      active: '#ffc1c1',
      disabled: '#ffecec',
      text: FICColors.red,
      textHover: FICColors.red
    },
    green: {
      normal: '#e4f9ed',
      hover: '#c7f3da',
      active: '#a6ecc5',
      disabled: '#e4f9ed',
      text: FICColors.green,
      textHover: FICColors.green
    },
    white: {
      normal: FICColors.gray,
      hover: '#ebedee',
      active: '#dde1e3',
      disabled: FICColors.gray,
      text: FICColors.black,
      textHover: FICColors.black
    }
  }
}

FICColors.link = {
  normal: FICColors.blue,
  hover: '#0B8AC0',
  gray: '#5C6E77'
}

FICColors.text = {
  gray: '#5C6E77'
}

export default FICColors



// WEBPACK FOOTER //
// ./src/common/styles/FICColors.js